<template>
    <div>
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <app-breadcrumb :page-title="$t('location_list')" :directory="$t('list')" :icon="'grid'" />
                </div>
                <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                    <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                        <button 
                            @click=" addCountry = true, list = false"
                            type="button" class="btn btn-primary btn-with-shadow">
                            {{ $t('add_country') }}
                        </button>
                        <button 
                            @click=" addState = true, list = false"
                            type="button" class="btn btn-primary btn-with-shadow">
                            {{ $t('add_state') }}
                        </button>
                        <button 
                            @click=" addCity = true, list = false"
                            type="button" class="btn btn-primary btn-with-shadow">
                            {{ $t('add_city') }}
                        </button>
                    </div>
                </div>
            </div>
            <app-table :id="tableId" :options="options" @action="getListAction" :selected-url="selectedUrl" />
        </div>
        <AddCountry  
            v-if="addCountry"
            @close="addCountry = false"
            @save="handleSaveCountry" />
        <addState 
            v-if="addState"
            @close="addState = false"
            @save="handleSaveState" />
        <addCity
            v-if="addCity"
            @close="addCity = false"
            @save="handleSaveCity" /> 
             
        <app-delete-modal 
            v-if="deleteConfirmationModalActive" 
            :preloader="deleteLoader" 
            modal-id="demo-delete"
            @confirmed="confirmed" 
            @cancelled="cancelled" />

        <EditCity
            v-if="editCity"
            :city_id="this.rowData.city_id"
            @close="editCity = false"
            @save="handleUpdateCity" />    

    </div>
</template>

<script>
import configTable from "./mixins/configTable";
import * as actions from "../../../Config/ApiUrl.js";
import { FormMixin } from '../../../../core/mixins/form/FormMixin.js';
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import AddCountry from "./AddCountry.vue";
import AddState from "./AddState.vue";
import AddCity from "./AddCity.vue";
import EditCity from "./EditCity.vue";
import { tableLocation } from './mixins/tableLocation.js';
import { saveCountry, saveState, saveCity, deleteCity, updateCity } from "./api/api";

export default {
    extends: CoreLibrary,
    mixins: [tableLocation, FormMixin],
    components :{
        AddCountry, AddState, AddCity, EditCity
    },  
    data() {
        return {
            tableId: 'advance-table',
            options: configTable,
            addCountry : false,
            addState : false,
            addCity : false,
            editCity : false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            rowData: {},
        }
    },
    created() {
        this.options.columns = this.tableColumns; // Asignar las columnas de la tabla
    },
    methods : {
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            if (actionObj.title === 'Delete') {
                this.openDeleteModal();
            }
            if (actionObj.title === 'Edit') {
                this.openEditModal();
            }
        },  

        async handleSaveCountry(name, code){
            const res = await saveCountry(name, code);
            if (res.created) {
                this.$toastr.s(res.message);
                this.addCountry = false;
                return;
            }
            this.$toastr.e(res.message);
        },

        async handleSaveState(country, code, state){
            const res = await saveState(country, code, state);
            if (res.created) {
                this.$toastr.s(res.message);
                this.addState = false;
                return;
            }
            this.$toastr.e(res.message);
        },

        async handleSaveCity(country, state, city) {
            const res = await saveCity(state, city);
            if (res.created) {
                this.$toastr.s(res.message);
                this.addCity = false;
                return;
            }
            this.$toastr.e(res.message);
        },

        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        cancelled() {
            this.deleteConfirmationModalActive = false;
            location.reload();
        },

        async confirmed() {
            const id = this.rowData.city_id;
            const res = await deleteCity(id);
            if (res.deleted) {
                $("#demo-delete").modal('hide');
                this.$toastr.s(res.message);
                this.cancelled();
                return;
            }
            this.$toastr.e(res.message);
        },

        openEditModal() {
            this.editCity = true;
        },

        async handleUpdateCity(city, city_id){
            const res = await updateCity(city, city_id);
            if (res.updated) {
                this.$toastr.s(res.message);
                this.editCity = false;
                location.reload();
                return;
            }
            this.$toastr.e(res.message);
        }
    },
}
    
</script>

